import '../../components/Products/ProductsStripe.css';

import axios from 'axios';
import { useEffect, useState } from 'react';
import { Button, Grid, IconButton, Typography } from '@material-ui/core';

import lines from './lines.svg';
import checkGreen from './check-green.svg';
import check from './check-selected.png';
import ButtonSvg from './ButtonSvg';
import DoubleArrowIcon from '@material-ui/icons/DoubleArrow';
import { useWindowDimensions } from '../../utilities/constants';
import { motion } from 'framer-motion';
import { SkeletonLoader } from '../../pure-ui/SkeletonLoader/SkeletonLoader';
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';

export const BASE_URL = process.env.REACT_APP_VIRTUALASSISSTANT_API_ADDRESS;
const API_BASE_URL = BASE_URL + '/api';

const ProductRegistration = (props) => {
  const { isAdded, onAdd, renderButtons } = props;
  const { innerWidth } = useWindowDimensions();
  const [products, setProducts] = useState([]);
  const [nextProducts, setNextProducts] = useState(false);
  const [isLoading, setisLoading] = useState(false);

  useEffect(() => {
    const fetchProducts = async () => {
      setisLoading(true);
      try {
        const { data } = await axios.get(`${API_BASE_URL}/products/getUserProducts`);
        const newProducts = data.sort((p1, p2) => {
          if (p1.ProductUserCount && p2.ProductUserCount) {
            return p1.ProductUserCount - p2.ProductUserCount;
          } else if (p1.ProductUserCount) {
            return -1;
          } else if (p2.ProductUserCount) {
            return 1;
          }

          return p1.PriceUnitUnitAmountDecimal - p2.PriceUnitUnitAmountDecimal;
        });
        setProducts(newProducts);
        const freePackage = newProducts.filter(
          (prod) => prod.PriceUnitUnitAmountDecimal === 0 && prod.ProductAppType === '3'
        )[0];
        onAdd(
          freePackage?.ProductId,
          freePackage?.PriceId,
          freePackage?.PriceUnitUnitAmountDecimal,
          false
        );
      } catch (error) {
        console.log(error);
      } finally {
        setisLoading(false);
      }
    };
    fetchProducts();
  }, []);

  const createFeaturesArray = (product) => {
    return [
      `Allowed Users: ${product.ProductUserCount}`,
      'Chat, Task, Calendar, Phonebook',
      'Push on settings',
      'Users Manager',
    ];
  };

  const displayableProducts = products.filter((prod) => prod.ProductUserCount !== '');

  const hasMoreProducts = displayableProducts.length > 3;

  return (
    <Grid container spacing={2} direction="column" alignContent="center">
      <div className="relative p-4 md:p-6 flex flex-col w-full">
        <div className="relative z-2 self-center w-full">
          <div className="w-full max-w-[1250px] min-h-[500px] h-auto gap-[20px] flex flex-col mx-auto mt-6">

            {isLoading ? (
              <div className="flex flex-row w-full justify-center items-center">
                {/* Skeleton Loader: Stack vertically on mobile, row on desktop */}
                <div className="flex flex-col lg:flex-row w-full max-w-[1200px] gap-5 items-center">
                  {[1, 2, 3].map((box) => (
                    <div key={box} className="flex flex-col w-full lg:w-1/3 p-3">
                      <SkeletonLoader className="h-[125px] w-full rounded-xl mb-5" />
                      <SkeletonLoader className="h-4 w-[90%] rounded-xl mb-2" />
                      <SkeletonLoader className="h-4 w-[80%] rounded-xl" />
                    </div>
                  ))}
                </div>
              </div>
            ) : (
              <>
                <div className="flex flex-col w-full box-border mt-6 md:mt-12">
                  <motion.div
                    key={nextProducts ? '1' : '0'}
                    initial={{ opacity: 0, x: nextProducts ? '100%' : '-100%' }}
                    animate="visible"
                    variants={{
                      visible: { opacity: 1, x: 0 },
                    }}
                    transition={{ duration: 0.5, ease: 'easeInOut' }}
                    className="flex flex-wrap justify-center gap-6 w-full max-w-[1400px] self-center relative box-border"
                  >
                    {displayableProducts
                      .slice(
                        innerWidth < 1024 ? 0 : nextProducts ? 2 : 0,
                        innerWidth < 1024 ? 6 : nextProducts ? 5 : 3
                      )
                      .map((item, index) => (
                        <div
                          key={index}
                          className={`w-full max-w-[350px] lg:w-[306px] min-h-[480px] p-6 border rounded-[12px] flex flex-col gap-[16px] box-border ${isAdded(item.ProductId)
                            ? 'bg-[#10B981] text-white border-[#10B981]'
                            : 'bg-white text-black border-[#666]'
                            }`}
                          style={{
                            boxShadow: '0px 6px 16px 0px #0000001A',
                            outline: isAdded(item.ProductId) ? '2px solid #10B981' : 'none',
                            outlineOffset: '2px',
                          }}
                        >
                          <Typography
                            style={{
                              fontFamily: 'Inter, sans-serif',
                              fontWeight: 700,
                              fontSize: '24px',
                              lineHeight: '100%',
                              letterSpacing: '0%',
                              color: isAdded(item.ProductId) ? 'white' : '#191D23',
                            }}
                          >
                            {item.ProductName}
                          </Typography>

                          <Typography
                            style={{
                              fontFamily: 'Inter, sans-serif',
                              fontWeight: 400,
                              fontSize: '16px',
                              lineHeight: '100%',
                              letterSpacing: '0%',
                              color: isAdded(item.ProductId) ? '#E0E7EF ' : '#64748B',
                            }}
                          >
                            {item.PriceUnitUnitAmountDecimal === 0
                              ? 'Limited Features'
                              : 'Limits Removed completely'}
                          </Typography>

                          <Typography
                            style={{
                              fontFamily: 'Inter, sans-serif',
                              fontWeight: 600,
                              fontSize: '56px',
                              lineHeight: '100%',
                              letterSpacing: '0%',
                              color: isAdded(item.ProductId) ? 'white' : '#191D23',
                            }}
                          >
                            ${' '}
                            {(item.PriceUnitUnitAmountDecimal / 100).toFixed(2)}
                          </Typography>

                          <Button
                            variant="outlined"
                            onClick={() =>
                              onAdd(
                                item.ProductId,
                                item.PriceId,
                                item.PriceUnitUnitAmountDecimal,
                                false
                              )
                            }
                            className="w-full"
                            style={{
                              height: '51px',
                              borderWidth: '1.5px',
                              borderColor: '#10B981',
                              borderRadius: '8px',
                              padding: '16px 24px',
                              color: '#10B981',
                              textTransform: 'none',
                              fontWeight: 500,
                              fontFamily: 'Inter',
                              gap: '10px',
                              backgroundColor: '#FFFFFF',
                            }}
                          >
                            {isAdded(item.ProductId) ? 'Selected' : 'Select'}
                          </Button>

                          <ul className="p-0 m-0">
                            {createFeaturesArray(item).map((feature, index) => (
                              <li
                                key={index}
                                className="flex items-start py-1 box-border"
                              >
                                <img
                                  src={isAdded(item.ProductId) ? check : checkGreen}
                                  width={24}
                                  height={24}
                                  className="rounded-full bg-transparent"
                                  alt="Check"
                                />
                                <p className="text-[0.875rem] leading-6 md:text-base ml-4 my-0 text-left">
                                  {feature}
                                </p>
                              </li>
                            ))}
                          </ul>
                        </div>
                      ))}

                    {/* Navigation Arrows: Hidden on screens smaller than 1024px */}
                    <div
                      className={`absolute flex flex-row w-full justify-between top-1/2 -translate-y-1/2 pointer-events-none ${innerWidth < 1024 ? 'hidden' : ''
                        }`}
                    >
                      <IconButton
                        onClick={() => setNextProducts(false)}
                        disabled={!nextProducts}
                        className="-translate-x-[120%] pointer-events-auto"
                        style={{
                          width: '48px',
                          height: '48px',
                          backgroundColor: !nextProducts ? '#D1D5DB' : '#10B981',
                          borderRadius: 8,
                          color: 'white',
                        }}
                      >
                        <ArrowBackIosNewIcon fontSize="small" />
                      </IconButton>

                      <IconButton
                        onClick={() => setNextProducts(true)}
                        // Disable if already on next OR if we have 3 or fewer products in total
                        disabled={nextProducts || !hasMoreProducts}
                        className="translate-x-[120%] pointer-events-auto"
                        style={{
                          width: '48px',
                          height: '48px',
                          // Gray out the background if disabled
                          backgroundColor: (nextProducts || !hasMoreProducts) ? '#D1D5DB' : '#10B981',
                          borderRadius: 8,
                          color: 'white',
                        }}
                      >
                        <ArrowForwardIosIcon fontSize="small" />
                      </IconButton>
                    </div>
                  </motion.div>
                </div>
              </>
            )}

            <div className="max-w-[528px] w-full gap-4 mx-auto mt-4">
              {props.renderButtons && props.renderButtons()}
            </div>
          </div>
        </div>
      </div>
    </Grid>
  );
};

export default ProductRegistration;